import React, { Component } from 'react'
import { Header, Button, Segment, Message, Form } from 'semantic-ui-react'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'

import UserInput from './UserInput'

class CopyUsers extends Component {
  state = {
    sourceId: '',
    destId: '',
    message: null,
  }

  handleChange = event => {
    this.setState({ [event.target.id]: event.target.value })
  }

  handleDismiss = () => this.setState({ message: null })

  render() {
    const { destId, sourceId, message } = this.state
    return (
      <Segment>
        <Header as="h3">Copy Users</Header>
        <Form>
          <Form.Group>
            <UserInput
              id="sourceId"
              label="Source ID (copy this user's data)"
              value={sourceId}
              onChange={this.handleChange}
            />
            <UserInput
              id="destId"
              label="Destination ID (over this user's data)"
              value={destId}
              onChange={this.handleChange}
            />
          </Form.Group>

          {message && (
            <Message onDismiss={this.handleDismiss}>
              <Message.Header>{message}</Message.Header>
            </Message>
          )}

          <Mutation mutation={COPY_USER}>
            {(copyUser, { data, loading, error }) => {
              return loading ? (
                <Button disabled>Copying...</Button>
              ) : (
                <div>
                  {error && (
                    <Message>
                      <Message.Header>
                        {error.graphQLErrors[0].message}
                      </Message.Header>
                      <p>
                        <span style={{ color: 'red' }}>
                          Possible invalid user ID
                        </span>
                      </p>
                    </Message>
                  )}
                  <Button
                    onClick={async () => {
                      await copyUser({ variables: { sourceId, destId } })
                      this.setState({
                        message: `Successfully copied data to user: ${destId}`,
                      })
                    }}
                  >
                    Copy
                  </Button>
                </div>
              )
            }}
          </Mutation>
        </Form>
      </Segment>
    )
  }
}

const COPY_USER = gql`
  mutation CopyUser($destId: ID!, $sourceId: ID!) {
    copyUser(destId: $destId, sourceId: $sourceId) {
      id
      firstName
      email
      fbId
    }
  }
`

export default CopyUsers
